import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Input } from "../input";

interface EditTitleDialogProps {
  isOpen: boolean;
  title: string;
  onChangeTitle: (title: string) => void;
  onCancel: () => void;
  onSave: () => void;
}

export const EditTitleDialog = ({
  isOpen,
  title,
  onChangeTitle,
  onCancel,
  onSave,
}: EditTitleDialogProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("visit.updateTitle")}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <Input
            className="w-full border p-2"
            type="text"
            value={title}
            onChange={(event) => {
              onChangeTitle(event.target.value);
            }}
          />
        </div>
        <DialogFooter>
          <Button variant={"outline"} onClick={onCancel}>
            {t("common.cancel")}
          </Button>
          <Button onClick={onSave}>{t("common.save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
